module.exports = __webpack_public_path__ + "static/media/company.eed23e83.svg";